module.exports = __webpack_public_path__ + "static/media/chrome-app-info.b4e8543c.jpeg";